import { render, staticRenderFns } from "./RoomCardShimmer.vue?vue&type=template&id=3f646a36&scoped=true&"
import script from "./RoomCardShimmer.vue?vue&type=script&lang=js&"
export * from "./RoomCardShimmer.vue?vue&type=script&lang=js&"
import style0 from "./RoomCardShimmer.vue?vue&type=style&index=0&id=3f646a36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f646a36",
  null
  
)

export default component.exports